import '@fortawesome/fontawesome-free/css/all.css';
import Main from './layouts/main/Main';
import Navbar from './layouts/navbar/Navbar';
import Footer from './layouts/footer/Footer';
import React, { useEffect } from 'react';
import store, { StateModel, storeType } from './redux/store';
import { connect } from 'react-redux';
import 'typeface-roboto';
import { BrowserRouter as Router } from 'react-router-dom';

import Spinner from './components/spinner/Spinner';
import { AuthModel } from './models/AuthModel';
import { ClientconfigService, LoginService } from './api';
import jwtDecode from 'jwt-decode';
import { ActionTypes } from './redux/actions/types';
import { initializeHttpClient } from './config/axios-config';
import { setInitialization } from './redux/actions/initialization';

export interface AppProps {
  isInitialized: boolean;
  setInitialization: (value: boolean) => void;
}

const initState = (store: storeType) => {
  const authState: AuthModel = store.getState().Auth;
  if (authState.accessToken && authState.refreshToken) {
    const auth = {
      accessToken: authState.accessToken,
      refreshToken: authState.refreshToken,
    };
    new LoginService().refreshTokens(auth).then(response => {
      const accessToken = response?.data?.accessToken;
      if (accessToken) {
        const decodedToken: any = jwtDecode(accessToken);
        const params = JSON.parse(decodedToken['client-config-params']);
        store.dispatch({
          type: ActionTypes.SET_CLIENT_CONFIG,
          payload: params,
        });
        store.dispatch({
          type: ActionTypes.SET_AUTHENTICATION,
          payload: response.data,
        });
        store.dispatch({
          type: ActionTypes.SET_INITIALIZED,
          payload: true,
        });
      } else {
        store.dispatch({
          type: ActionTypes.SET_INITIALIZED,
          payload: true,
        });
      }
    });
  } else {
    new ClientconfigService().getClientConfig().then(response => {
      store.dispatch({
        type: ActionTypes.SET_CLIENT_CONFIG,
        payload: response.data,
      });
    });
    store.dispatch({
      type: ActionTypes.SET_INITIALIZED,
      payload: true,
    });
  }
};

const App = (props: AppProps) => {
  useEffect(() => {
    initializeHttpClient(store);
    initState(store);
  }, []);

  return props.isInitialized ? (
    <Router basename='/disponent-online'>
      <div className='App'>
        <Navbar />
        <Main />
        <Footer />
      </div>
    </Router>
  ) : (
    <Spinner isLoading={!props.isInitialized} />
  );
};

const mapStateToProps = (state: StateModel) => ({
  isInitialized: state.Initialization.isInitialized,
  accessToken: state.Auth.accessToken,
  refreshToken: state.Auth.refreshToken,
});

export default connect(mapStateToProps, { setInitialization })(App);
